export const RESET = "RESET"

// team follow
export const FOLLOW_TEAM_REQUEST = 'FOLLOW_TEAM_REQUEST'
export const FOLLOW_TEAM_SUCCESS = 'FOLLOW_TEAM_SUCCESS'
export const FOLLOW_TEAM_FAILURE = 'FOLLOW_TEAM_FAILURE'
